module.exports = __webpack_public_path__ + "static/media/tap_04_img07.c69c8e59.png";